/// <reference path="../../invoicing.module.ts" />
import { Component, OnInit } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { ActivatedRoute } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { appSettings } from '../../../shared/components/appSettings';
import { FileDownloadService } from '@services/file-download/file-download.service';
import { DialogModule } from 'primeng/dialog';
import { CustomInvoiceBlade } from '@framework/components/mf-blade/MfBladeExt';
import { CalendarModule } from 'primeng/calendar';
import { InvoiceItemType } from '../../Enums';
import { IdentityAuthService } from '../../../../services/identity-auth/identity-auth.service';
import { debug } from 'util';


Date.prototype["shortDate"] = function () {
  if (this == null) return null;
  if (window["moment"]) {
    return window["moment"](this).format("DD MMM YYYY");
  }
  else {
    return this.getDate() + " " + this["monthName"]() + " " + this.getFullYear();
  }
}
@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.css']
})
export class InvoiceDetailsComponent implements OnInit {
  loading: boolean = false;
  entityData: any;
  _entityId: any;
  parent: any;
  displayDialog: boolean = false;
  dialogContent = "test";
  VAT: number = 0.15;
  public get entityId() { return this._entityId };
  public set entityId(value) {
    if (this._entityId == value)
      return;
    this._entityId = value; this.loadEntity();
  }
  constructor(private apiService?: ApiService, private route?: ActivatedRoute,
    private messageService?: NbToastrService, private confirmationService?: ConfirmationService, private fileDownloadService?: FileDownloadService,
    public auth?: IdentityAuthService) {

   // debugger;
  }
  public get IsCreditNote(): boolean{
    if (!this.entityData) {
      return false;
    }
    let value: boolean = this.entityData.invoiceItemTypeId == InvoiceItemType.CreditNote
    return value;
  }
  private _processingDate;
  public get ProcessingDate(){
    //debugger;
    if (isNaN(this._processingDate)) {

      return null;
    }
      if (this._processingDate)
        return this._processingDate;

  }
  public set ProcessingDate(value) {
    if (!value) {
      this._processingDate = null;
      if (this.entityData)
        this.entityData.processingDate = null;
    }
    else {
      this._processingDate = new Date(value);
      if (this.entityData)
        this.entityData.processingDate = new Date(value);
    }
  }
  public GetAmount(amount): string{
    if (!amount) amount = " ";
    let a = amount.toString().replace(/[^\d.-]/g, '');
    let x = Number(a);
    let k = x.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var t = k.toString().replace(/,/g, " ");
    return t;
  }
  public loadEntity() {
    let self: InvoiceDetailsComponent = this;
    if (!self.entityId) return;
    self.loading = true;
    this.apiService.get(`/api/Invoice/detail/${this.entityId}`)
      .subscribe(o => {
        self.entityData = o;
        self.ProcessingDate = o.processingDate;
        self.loading = false;
        //debugger;
        //let f = this.auth.hasAnyPermissions();
      }, err => {
        self.loading = false;
        self.messageService.danger('error', 'Could not load');
      })
  }
  
  public download() {
    let endPoint: string = "/api/headOfficeInvoiceItem/download/" + this.entityId;
    this.fileDownloadService.downloadFile(endPoint, `${this.entityData.invoiceNo}.pdf`);
   
  }
  public downloadCreditNote() {
    let endPoint: string = "/api/headOfficeInvoiceItem/downloadCreditNote/" + this.entityId;
    this.fileDownloadService.downloadFile(endPoint, `${this.entityData.creditNoteNo}.pdf`);

  }
  public save() {
    let self: InvoiceDetailsComponent = this;
    if (!self.entityId) return;
    self.loading = true;
    this.apiService.post(`/api/Invoice/updateInvoiceNo/${this.entityId}`, this.entityData)
      .subscribe(o => {
        self.loading = false; debugger;
        if (self.parent.parent)
            self.parent.parent.getBladeByIndex(0).reload()
          self.messageService.success('Saved successfully', 'Action');
      }, err => {
          if (err.status == 409) {
            self.loading = false;
            self.displayDialog = true;
            self.dialogContent = err.error;
          }
          else {
            self.loading = false;
            self.messageService.danger('error', 'Could not save');
          }
        }

    )

  }
  public Total(item): string {
    if (item.unitPrice == 0 || item.quantity == 0)
      return this.GetAmount(0);

    return this.GetAmount(item.unitPrice * item.quantity);
  }

  public cancel() {
    if (this.parent && this.parent.selectedItem)
      this.parent.selectedItem = null;
    if (this.parent && this.parent.closeBlade)
      this.parent.closeBlade();
  }

  public submit() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to submit ',
      accept: () => {
        let self: InvoiceDetailsComponent = this;
        this.apiService.post(`/api/Invoice/submitInvoice/${this.entityId}`, this.entityData)
          .subscribe(o => {
            self.loading = false;
            if (self.parent && self.parent.loadData)
              self.parent.loadData();
            this.parent && this.parent.selectedItem ? this.parent.selectedItem = null : this
            if (this.parent) {
              let parentBlade: CustomInvoiceBlade = this.parent;
              parentBlade.closeBlade();
              if (parentBlade.parent)
                parentBlade.parent.getBladeByIndex(0).reload()
            }
            self.messageService.success('Saved successfully', 'Action');
          }, err => {
              if (err.status == 409) {
                self.loading = false;
                self.displayDialog = true;
                self.dialogContent = err.error;
              }
              else {
                self.loading = false;
                self.messageService.danger('error', 'Could not save');
              }
          })
      }
    });
  }
  public GetVat(InvoiceLineItems: Array<any>) {
    let total: number = this.CalculateTotal(InvoiceLineItems);
    let vat: number = total * this.VAT;
    return this.GetAmount(vat);
  }
  private CalculateTotal(InvoiceLineItems: Array<any>): number {
    let total: number = 0;
    if (InvoiceLineItems && InvoiceLineItems.length > 0) {
      InvoiceLineItems.forEach(i => {
        total += i.unitPrice * i.quantity;
      })
    }
    return total;
  }
  public GetSubTotal(InvoiceLineItems: Array<any>) {
    //let total: number = 0;
    //if (InvoiceLineItems && InvoiceLineItems.length > 0) {
    //  InvoiceLineItems.forEach(i => {
    //    total += i.unitPrice * i.quantity;
    //  })
    //}
    return this.GetAmount(this.CalculateTotal(InvoiceLineItems));
  }
  public GetTotal(InvoiceLineItems: Array<any>) {
    let total: number = this.CalculateTotal(InvoiceLineItems);
    let vat: number = total * (1 + this.VAT);

    return this.GetAmount(vat);
  }
  ngOnInit() {
    if (this.parent && this.parent.entityIdChange) {
      this.entityId = this.parent.entityId;
      this.parent.entityIdChange.subscribe(entityId => {
        this.entityId = entityId;
      })
    }
    else {
        this.route.params.subscribe(params => {
          this.entityId = params['id'];
        })
    }
    //this.route.params.subscribe(params => {
    //  this.entityId = params['id'];
    //})
  }

 

}
